import styled from 'styled-components';
import { Box, Table, TableCell, TableRow } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

// Styled Components
export const StyledTableHeadCell = styled(TableCell)<{ $width?: number }>`
  background-color: var(--color-bg-purple-tint);
  border-bottom: 1px solid #d0d5dd;
  padding: 16px;
  white-space: nowrap;
  ${props => props.$width ? `width: ${props.$width}px; min-width: ${props.$width}px;` : ''}

  & .MuiTypography-root {
    font-family: 'Inter';
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: var(--color-text-purple);
  }

  & .MuiTableSortLabel-root {
    &:hover {
      color: inherit !important;
    }

    .MuiTableSortLabel-icon {
      opacity: 1 !important;
    }
  }

  &:hover .MuiTableSortLabel-root {
    color: inherit !important;

    .MuiTableSortLabel-icon {
      color: inherit !important;
    }
  }
`;

export const StyledTableRow = styled(TableRow)`
  border-bottom: 1px dashed;
  border-color: var(--color-border-medium);

  &:hover {
    background-color: var(--color-bg-purple-tint);
  }
`;

export const StyledTableCell = styled(TableCell)<{ $width?: number }>`
  padding: 11px 16px !important;
  white-space: nowrap;
  ${props => props.$width && `width: ${props.$width}px; min-width: ${props.$width}px;`}
`;

export const TableWrapper = styled(Box)`
  width: 100%;
  overflow-x: auto;
  box-shadow: none;
  outline: 1px solid rgb(250, 250, 250);
  border-radius: 0;
  max-width: 100%;
  background-color: var(--color-white);
  
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: var(--color-bg-grey3);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
    
    &:hover {
      background: #a8a8a8;
    }
  }
`;

export const StyledTable = styled(Table)``;

// Sx Styles
export const checkboxSx: SxProps<Theme> = {
  padding: '0px'
};

export const tableCellTypographySx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: 'var(--line-height-18)',
  color: 'var(--color-text-near-black)'
};

